import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import moduleAuth from "./auth/moduleAuth.js";
import moduleStation from "./stations/moduleStation.js";
import moduleDropdownlist from "./dropdownlist/moduleDropdownlist.js";
import moduleCoop from "./coops/moduleCoop.js";
import moduleEmployee from "./employees/moduleEmployee";
import moduleConsultant from "./consultants/moduleConsultant";
import modulePeriod from "./period/modulePeriod.js";
import moduleEnum from "./enum";
import moduleToaster from "@/toaster/ToasterStore";

const store = new Vuex.Store({
  state: {
    width: document.documentElement.clientWidth,
    subMenu: false,
    navMenu: false,
  },
  getters: {},
  mutations: {},
  actions: {
    initialize({ dispatch }) {
      dispatch("enum/initialize");
    },
    getWidth() {
      window.addEventListener("resize", () => {
        this.state.width = document.documentElement.clientWidth;
      });
    },
    openSubmenu() {
      this.state.subMenu = true;
    },
    closeSubmenu() {
      this.state.subMenu = false;
    },
    openMenu() {
      this.state.navMenu = true;
    },
    closeMenu() {
      this.state.navMenu = false;
    },
    toggleMenu() {
      this.state.navMenu = !this.state.navMenu;
    },
  },
  modules: {
    auth: moduleAuth,
    station: moduleStation,
    dropdownlist: moduleDropdownlist,
    coop: moduleCoop,
    employee: moduleEmployee,
    consultant: moduleConsultant,
    period: modulePeriod,
    enum: moduleEnum,
    toaster: moduleToaster,
  },
});

export default store;
